type ClickLike = {
  metaKey?: boolean
  ctrlKey?: boolean
  shiftKey?: boolean
  button?: number
}

// True when a click should be left to the browser (open in a new tab/window)
// instead of being intercepted for in-app navigation: a modifier key is held
// or the middle mouse button was used.
const isModifiedClick = (event: ClickLike): boolean =>
  Boolean(event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1)

export default isModifiedClick
